var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"productSwiper"}},[(_vm.productImg.length>0)?_c('swiper',{staticClass:"swiper swiper-no-swiping",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.productImg),function(item){return _c('swiper-slide',{key:item.id},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.$imgBaseURL+item.bg_url,"alt":""}})])])}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }